import { FIELD_TYPE } from '../constants/Constants';
import { IAddressAttributes } from '../domain/entities/Address';

// Don't use this anywhere, is just used to map an API response
// that uses this deprecated field naming convention.
enum ADDRESS_FIELD {
  COUNTRY = 'country',
  FIRST_LINE_ADDRESS = 'firstLineAddress',
  SECOND_LINE_ADDRESS = 'secondLineAddress',
  THIRD_LINE_ADDRESS = 'thirdLineAddress',
  FOURTH_LINE_ADDRESS = 'fourthLineAddress',
  FIFTH_LINE_ADDRESS = 'fifthLineAddress',
  ZIP_CODE = 'zipcode',
  CITY = 'city',
  COLONY = 'colony',
  MUNICIPALITY = 'municipality',
  STATE = 'state',
  MOBILE_NUMBER = 'mobileNumber',
  SECOND_NUMBER = 'secondPhoneNumber',
  DELIVERY_INSTRUCTIONS = 'deliveryInstructions',
  COMPANY_NAME = 'companyName',
  COMPANY_ADDRESS = 'companyAddress',
  COMPANY_TAX_NUMBER = 'companyTaxNumber',
  COUNTRY_ID = 'countryId',
  CREATED_DATE = 'createdDate',
  DEFAULT_SHIPPING = 'defaultShipping',
  ID = 'id',
  MOBILE_NUMBER_TYPE = 'mobileNumberType',
  SECOND_PHONE_NUMBER_TYPE = 'secondPhoneNumberType',
  UPDATED_DATE = 'updatedDate',
  ADDRESS_TYPE = 'addressType',
}

const ADDRESS_FIELD_SCHEMA_MAPPINGS: Partial<Record<ADDRESS_FIELD, FIELD_TYPE>> = {
  [ADDRESS_FIELD.FIRST_LINE_ADDRESS]: FIELD_TYPE.FIRST_LINE_ADDRESS,
  [ADDRESS_FIELD.SECOND_LINE_ADDRESS]: FIELD_TYPE.SECOND_LINE_ADDRESS,
  [ADDRESS_FIELD.THIRD_LINE_ADDRESS]: FIELD_TYPE.THIRD_LINE_ADDRESS,
  [ADDRESS_FIELD.FOURTH_LINE_ADDRESS]: FIELD_TYPE.FOURTH_LINE_ADDRESS,
  [ADDRESS_FIELD.FIFTH_LINE_ADDRESS]: FIELD_TYPE.FIFTH_LINE_ADDRESS,
  [ADDRESS_FIELD.CITY]: FIELD_TYPE.CITY,
  [ADDRESS_FIELD.COLONY]: FIELD_TYPE.COLONY,
  [ADDRESS_FIELD.MUNICIPALITY]: FIELD_TYPE.MUNICIPALITY,
  [ADDRESS_FIELD.COUNTRY]: FIELD_TYPE.COUNTRY_LABEL,
  [ADDRESS_FIELD.COUNTRY_ID]: FIELD_TYPE.COUNTRY_ID,
  [ADDRESS_FIELD.DELIVERY_INSTRUCTIONS]: FIELD_TYPE.DELIVERY_INSTRUCTIONS,
  [ADDRESS_FIELD.MOBILE_NUMBER]: FIELD_TYPE.PHONE,
  [ADDRESS_FIELD.SECOND_NUMBER]: FIELD_TYPE.SECOND_PHONE,
  [ADDRESS_FIELD.ZIP_CODE]: FIELD_TYPE.ZIPCODE,
  [ADDRESS_FIELD.STATE]: FIELD_TYPE.STATE,
  [ADDRESS_FIELD.COMPANY_NAME]: FIELD_TYPE.COMPANY_NAME,
  [ADDRESS_FIELD.COMPANY_TAX_NUMBER]: FIELD_TYPE.COMPANY_TAX_NUMBER,
  [ADDRESS_FIELD.COMPANY_ADDRESS]: FIELD_TYPE.COMPANY_ADDRESS,
};

export default (fieldNames: string[]): (keyof IAddressAttributes)[] => fieldNames.map(name => {
  if (Object.keys(ADDRESS_FIELD_SCHEMA_MAPPINGS).includes(name)) {
    return ADDRESS_FIELD_SCHEMA_MAPPINGS[name as ADDRESS_FIELD] as keyof IAddressAttributes;
  }
  return name as keyof IAddressAttributes;
});
